<template>
  <page-header title="Пользователи" icon="bi-person-lines-fill"/>

  <std-table
      :format="[
        ['login','Логин/SID'],
        ['name','Фамилия Имя'],
        ['admin','Администратор', i=>i.admin?'Да':'Нет'],
        ['active','Активный', i=>i.active?'Да':'Нет'],
      ]"
      url="/users"
      resource="user"
      identity="login"
      :button="noEdit?null:'Создать новую учетную запись'"
  />
</template>

<script>
import PageHeader from "@/components/PageHeader";
import StdTable from "@/components/StdTable";
import {config} from "@/state/config";

export default {
  components: {StdTable, PageHeader},
  computed: {
    noEdit() {
      return !!config.keycloak;
    },
  },


}
</script>

